"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSE_ALL_MODALS = exports.CLOSE_MODAL = exports.OPEN_MODAL = exports.NETWORK_OFFLINE = exports.NETWORK_ONLINE = exports.SET_MEDIA_STATE = exports.SKIP_PROMO = exports.SET_SCROLL_STATE = exports.ACCEPT_CONDITIONS = exports.SET_RATINGS = exports.REMOVE_FAVORITE = exports.ADD_RECENT = exports.ADD_FAVORITE = exports.GET_CONTENTS_DOWNLOAD_PROGRESS = exports.GET_CONTENTS_DOWNLOAD_CANCEL = exports.GET_CONTENTS_DOWNLOAD_ERROR = exports.GET_CONTENTS_DOWNLOAD_SUCCESS = exports.GET_CONTENTS_DOWNLOAD_REQUEST = exports.SET_SEARCH_QUERY = exports.CHECK_UPDATES_ERROR = exports.CHECK_UPDATES_SUCCESS = exports.CHECK_UPDATES_REQUEST = exports.GET_HEROSHOT_ERROR = exports.GET_HEROSHOT_SUCCESS = exports.GET_HEROSHOT_REQUEST = exports.GET_FILE_ERROR = exports.GET_FILE_SUCCESS = exports.GET_FILE_REQUEST = exports.GET_LOCAL_ASSET_ERROR = exports.GET_LOCAL_ASSET_SUCCESS = exports.GET_LOCAL_ASSET_REQUEST = exports.GET_ASSET_ERROR = exports.GET_ASSET_SUCCESS = exports.GET_ASSET_REQUEST = exports.FLUSH_CONTENTS = exports.GET_IMAGE_MAPS_ERROR = exports.GET_IMAGE_MAPS_SUCCESS = exports.GET_IMAGE_MAPS_REQUEST = exports.SEARCH_CONTENTS_ERROR = exports.SEARCH_CONTENTS_CANCEL = exports.SEARCH_CONTENTS_SUCCESS = exports.SEARCH_CONTENTS_REQUEST = exports.GET_CONTENTS_ERROR = exports.GET_CONTENTS_SUCCESS = exports.GET_CONTENTS_REQUEST = exports.VEHICLES_RESET = exports.SET_VEHICLE_PRODUCT_SUBTYPE = exports.SET_VEHICLE_PRODUCT_TYPE = exports.SET_VEHICLE_GROUP = exports.SET_VEHICLE_MODEL = exports.SET_VEHICLE_YEAR = exports.SET_VEHICLE_BRAND = exports.SET_VEHICLE_ID = exports.GET_VEHICLES_ERROR = exports.GET_VEHICLES_SUCCESS = exports.GET_VEHICLES_REQUEST = void 0;
/** VEHICLE actions */

var GET_VEHICLES_REQUEST = 'GET_VEHICLES_REQUEST';
exports.GET_VEHICLES_REQUEST = GET_VEHICLES_REQUEST;
var GET_VEHICLES_SUCCESS = 'GET_VEHICLES_SUCCESS';
exports.GET_VEHICLES_SUCCESS = GET_VEHICLES_SUCCESS;
var GET_VEHICLES_ERROR = 'GET_VEHICLES_ERROR';
exports.GET_VEHICLES_ERROR = GET_VEHICLES_ERROR;
var SET_VEHICLE_ID = 'SET_VEHICLE_ID';
exports.SET_VEHICLE_ID = SET_VEHICLE_ID;
var SET_VEHICLE_BRAND = 'SET_VEHICLE_BRAND';
exports.SET_VEHICLE_BRAND = SET_VEHICLE_BRAND;
var SET_VEHICLE_YEAR = 'SET_VEHICLE_YEAR';
exports.SET_VEHICLE_YEAR = SET_VEHICLE_YEAR;
var SET_VEHICLE_MODEL = 'SET_VEHICLE_MODEL';
exports.SET_VEHICLE_MODEL = SET_VEHICLE_MODEL;
var SET_VEHICLE_GROUP = 'SET_VEHICLE_GROUP';
exports.SET_VEHICLE_GROUP = SET_VEHICLE_GROUP;
var SET_VEHICLE_PRODUCT_TYPE = 'SET_VEHICLE_PRODUCT_TYPE';
exports.SET_VEHICLE_PRODUCT_TYPE = SET_VEHICLE_PRODUCT_TYPE;
var SET_VEHICLE_PRODUCT_SUBTYPE = 'SET_VEHICLE_PRODUCT_SUBTYPE';
exports.SET_VEHICLE_PRODUCT_SUBTYPE = SET_VEHICLE_PRODUCT_SUBTYPE;
var VEHICLES_RESET = 'VEHICLES_RESET';
/** CONTENTS actions */

exports.VEHICLES_RESET = VEHICLES_RESET;
var GET_CONTENTS_REQUEST = 'GET_CONTENTS_REQUEST';
exports.GET_CONTENTS_REQUEST = GET_CONTENTS_REQUEST;
var GET_CONTENTS_SUCCESS = 'GET_CONTENTS_SUCCESS';
exports.GET_CONTENTS_SUCCESS = GET_CONTENTS_SUCCESS;
var GET_CONTENTS_ERROR = 'GET_CONTENTS_ERROR';
exports.GET_CONTENTS_ERROR = GET_CONTENTS_ERROR;
var SEARCH_CONTENTS_REQUEST = 'SEARCH_CONTENTS_REQUEST';
exports.SEARCH_CONTENTS_REQUEST = SEARCH_CONTENTS_REQUEST;
var SEARCH_CONTENTS_SUCCESS = 'SEARCH_CONTENTS_SUCCESS';
exports.SEARCH_CONTENTS_SUCCESS = SEARCH_CONTENTS_SUCCESS;
var SEARCH_CONTENTS_CANCEL = 'SEARCH_CONTENTS_CANCEL';
exports.SEARCH_CONTENTS_CANCEL = SEARCH_CONTENTS_CANCEL;
var SEARCH_CONTENTS_ERROR = 'SEARCH_CONTENTS_ERROR';
exports.SEARCH_CONTENTS_ERROR = SEARCH_CONTENTS_ERROR;
var GET_IMAGE_MAPS_REQUEST = 'GET_IMAGE_MAPS_REQUEST';
exports.GET_IMAGE_MAPS_REQUEST = GET_IMAGE_MAPS_REQUEST;
var GET_IMAGE_MAPS_SUCCESS = 'GET_IMAGE_MAPS_SUCCESS';
exports.GET_IMAGE_MAPS_SUCCESS = GET_IMAGE_MAPS_SUCCESS;
var GET_IMAGE_MAPS_ERROR = 'GET_IMAGE_MAPS_ERROR';
exports.GET_IMAGE_MAPS_ERROR = GET_IMAGE_MAPS_ERROR;
var FLUSH_CONTENTS = 'FLUSH_CONTENTS';
exports.FLUSH_CONTENTS = FLUSH_CONTENTS;
var GET_ASSET_REQUEST = 'GET_ASSET_REQUEST';
exports.GET_ASSET_REQUEST = GET_ASSET_REQUEST;
var GET_ASSET_SUCCESS = 'GET_ASSET_SUCCESS';
exports.GET_ASSET_SUCCESS = GET_ASSET_SUCCESS;
var GET_ASSET_ERROR = 'GET_ASSET_ERROR';
exports.GET_ASSET_ERROR = GET_ASSET_ERROR;
var GET_LOCAL_ASSET_REQUEST = 'GET_LOCAL_ASSET_REQUEST';
exports.GET_LOCAL_ASSET_REQUEST = GET_LOCAL_ASSET_REQUEST;
var GET_LOCAL_ASSET_SUCCESS = 'GET_LOCAL_ASSET_SUCCESS';
exports.GET_LOCAL_ASSET_SUCCESS = GET_LOCAL_ASSET_SUCCESS;
var GET_LOCAL_ASSET_ERROR = 'GET_LOCAL_ASSET_ERROR';
exports.GET_LOCAL_ASSET_ERROR = GET_LOCAL_ASSET_ERROR;
var GET_FILE_REQUEST = 'GET_FILE_REQUEST';
exports.GET_FILE_REQUEST = GET_FILE_REQUEST;
var GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
exports.GET_FILE_SUCCESS = GET_FILE_SUCCESS;
var GET_FILE_ERROR = 'GET_FILE_ERROR';
exports.GET_FILE_ERROR = GET_FILE_ERROR;
var GET_HEROSHOT_REQUEST = 'GET_HEROSHOT_REQUEST';
exports.GET_HEROSHOT_REQUEST = GET_HEROSHOT_REQUEST;
var GET_HEROSHOT_SUCCESS = 'GET_HEROSHOT_SUCCESS';
exports.GET_HEROSHOT_SUCCESS = GET_HEROSHOT_SUCCESS;
var GET_HEROSHOT_ERROR = 'GET_HEROSHOT_ERROR';
exports.GET_HEROSHOT_ERROR = GET_HEROSHOT_ERROR;
var CHECK_UPDATES_REQUEST = 'GET_UPDATES_REQUEST';
exports.CHECK_UPDATES_REQUEST = CHECK_UPDATES_REQUEST;
var CHECK_UPDATES_SUCCESS = 'GET_UPDATES_SUCCESS';
exports.CHECK_UPDATES_SUCCESS = CHECK_UPDATES_SUCCESS;
var CHECK_UPDATES_ERROR = 'GET_UPDATES_ERROR';
exports.CHECK_UPDATES_ERROR = CHECK_UPDATES_ERROR;
var SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
exports.SET_SEARCH_QUERY = SET_SEARCH_QUERY;
var GET_CONTENTS_DOWNLOAD_REQUEST = 'GET_CONTENTS_DOWNLOAD_REQUEST';
exports.GET_CONTENTS_DOWNLOAD_REQUEST = GET_CONTENTS_DOWNLOAD_REQUEST;
var GET_CONTENTS_DOWNLOAD_SUCCESS = 'GET_CONTENTS_DOWNLOAD_SUCCESS';
exports.GET_CONTENTS_DOWNLOAD_SUCCESS = GET_CONTENTS_DOWNLOAD_SUCCESS;
var GET_CONTENTS_DOWNLOAD_ERROR = 'GET_CONTENTS_DOWNLOAD_ERROR';
exports.GET_CONTENTS_DOWNLOAD_ERROR = GET_CONTENTS_DOWNLOAD_ERROR;
var GET_CONTENTS_DOWNLOAD_CANCEL = 'GET_CONTENTS_DOWNLOAD_CANCEL';
exports.GET_CONTENTS_DOWNLOAD_CANCEL = GET_CONTENTS_DOWNLOAD_CANCEL;
var GET_CONTENTS_DOWNLOAD_PROGRESS = 'GET_CONTENTS_DOWNLOAD_PROGRESS';
/** USER actions */

exports.GET_CONTENTS_DOWNLOAD_PROGRESS = GET_CONTENTS_DOWNLOAD_PROGRESS;
var ADD_FAVORITE = 'ADD_FAVORITE';
exports.ADD_FAVORITE = ADD_FAVORITE;
var ADD_RECENT = 'ADD_RECENT';
exports.ADD_RECENT = ADD_RECENT;
var REMOVE_FAVORITE = 'REMOVE_FAVORITE';
exports.REMOVE_FAVORITE = REMOVE_FAVORITE;
var SET_RATINGS = 'SET_RATINGS';
exports.SET_RATINGS = SET_RATINGS;
var ACCEPT_CONDITIONS = 'ACCEPT_CONDITIONS';
exports.ACCEPT_CONDITIONS = ACCEPT_CONDITIONS;
var SET_SCROLL_STATE = 'SET_SCROLL_STATE';
exports.SET_SCROLL_STATE = SET_SCROLL_STATE;
var SKIP_PROMO = 'SKIP_PROMO';
exports.SKIP_PROMO = SKIP_PROMO;
var SET_MEDIA_STATE = 'SET_MEDIA_STATE';
exports.SET_MEDIA_STATE = SET_MEDIA_STATE;
var NETWORK_ONLINE = 'NETWORK_ONLINE';
exports.NETWORK_ONLINE = NETWORK_ONLINE;
var NETWORK_OFFLINE = 'NETWORK_OFFLINE';
/** MODAL actions */

exports.NETWORK_OFFLINE = NETWORK_OFFLINE;
var OPEN_MODAL = 'OPEN_MODAL';
exports.OPEN_MODAL = OPEN_MODAL;
var CLOSE_MODAL = 'CLOSE_MODAL';
exports.CLOSE_MODAL = CLOSE_MODAL;
var CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
exports.CLOSE_ALL_MODALS = CLOSE_ALL_MODALS;